export default function installPolyfills() {
  require('core-js/features/promise/all-settled');
  require('core-js/features/array/flat-map');
  require('core-js/es/aggregate-error');
}
